// Google Consent Mode v2 helper
export const CONSENT_KEY = "ecominerali_consent_v2";

const DENIED = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  functionality_storage: "granted",
  personalization_storage: "denied",
  security_storage: "granted",
};

const GRANTED = {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
  functionality_storage: "granted",
  personalization_storage: "granted",
  security_storage: "granted",
};

function gtag() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

export function getStoredConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function applyConsent(consent) {
  gtag("consent", "update", consent);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "cookie_consent_update" });
}

export function updateConsent(partial) {
  const merged = { ...DENIED, ...(getStoredConsent() || {}), ...partial };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(merged));
  applyConsent(merged);
  return merged;
}

export function acceptAll() {
  return updateConsent(GRANTED);
}

export function rejectAll() {
  return updateConsent(DENIED);
}

export function hasStoredConsent() {
  return !!getStoredConsent();
}

export const CONSENT_DEFAULTS = DENIED;
export const CONSENT_GRANTED = GRANTED;
